import { useContext } from "react"
import { useStore } from "zustand"
import type { DropStore } from "@/components/collection/drops/drop-store"
import { CollectionDropContext } from "./CollectionDropContext"

export const useDropStore = <T>(selector: (store: DropStore) => T): T => {
  const context = useContext(CollectionDropContext)
  if (!context) {
    throw new Error("useDropStore must be used within a CollectionDropProvider")
  }
  return useStore(context, selector)
}
